import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px'
};

const sectionHeader: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '25px',
  color: 'customGrey.dark',
  margin: 0
};

const sectionTopRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px'
};

const viewAllLink: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '26px',
  color: 'primary.main',
  textDecorationColor: 'currentcolor',
  cursor: 'pointer'
};

export const searchCandidateProfileQueryHistoryPreviewSx = {
  container,
  sectionHeader,
  sectionTopRow,
  viewAllLink
};
